const BASE = '';

async function request(url, options = {}) {
  const token = sessionStorage.getItem('adminToken');
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(BASE + url, { ...options, headers });
  return res.json();
}

export const api = {
  get(url) { return request(url); },
  post(url, data) { return request(url, { method: 'POST', body: JSON.stringify(data) }); },
  put(url, data) { return request(url, { method: 'PUT', body: JSON.stringify(data) }); },
  del(url) { return request(url, { method: 'DELETE' }); },
  postForm(url, formData, method) {
    const token = sessionStorage.getItem('adminToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    return fetch(BASE + url, { method: method || 'POST', headers, body: formData }).then(r => r.json());
  },
  download(url) {
    const token = sessionStorage.getItem('adminToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    return fetch(BASE + url, { headers }).then(r => r.blob());
  }
};
